global.cloneFileInput = e => {
    const fileEl = e.target.cloneNode(true);
    const dataTransfer = new DataTransfer();
    Array.from(e.target.files).forEach(file => {
        dataTransfer.items.add(file);
    });
    fileEl.files = dataTransfer.files;
    return fileEl;
}
